<template>
  <div>
    <div class="relative flex items-center">
      <input
        class=""
        type="checkbox"
        :id="id"
        :checked="value"
        @keyup.enter="onClick"
        @click="onClick"
        @blur="$emit('blur')"
        @change="$emit('change')"
        :disabled="disabled"
      >
      <label
        class="flex items-center ml-2"
        :class="{'cursor-pointer': !disabled}"
        :for="id"
      >
        <slot />
      </label>
    </div>
    <ValidationMessages v-if="validations" :validations="validations" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'
import Validation from '@/mixins/Validation';

export default {

  name: 'BaseCheckbox',
  mixins: [Validation],
  components: {
    ValidationMessages
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: [Boolean, Number],
      required: true
    },
    validations: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onClick () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  input[type=checkbox]:not(.disable-styling)+label:before {
    display: none;
  }
  input[type=checkbox]:not(.disable-styling)+label {
    padding-left: 0.5rem;
  }
  input[type=checkbox]:not(.disable-styling):checked+label:after {
    display: none;
  }
  label {
    padding-left: 0;
    margin: auto 0;
  }
  .iconbg {
    z-index: 1;
  }
  .iconfg {
    z-index: 2;
  }
  .checkbox {
    width: 18px;
    height: 18px;
    margin-right: 20px;
  }
  svg {
    position: absolute;
    width: 18px;
    height: 18px;
  }

  input {
    // display: none;
  }
</style>
